/** Resolve which datacenter code the UI should use. URL wins when valid. */

const DEFAULT_RESERVED = [
  'tasks', 'netbox', 'monitoring', 'discovery', 'power', 'cables', 'topology',
  'connectivity', 'racks', 'equipment', 'placement', 'scenarios', 'admin', 'edit', 'floor-plan', 'calculator',
]

export function isDcCodeSegment(code: string | null | undefined, reserved: string[] = DEFAULT_RESERVED): boolean {
  return Boolean(code) && !reserved.includes(code as string)
}

/** Page data: prefer URL :dcCode, else store, else first from list. */
export function resolvePageDcCode(
  urlDc: string | undefined,
  storeDc: string | null | undefined,
  firstDc: string | undefined,
  reserved: string[] = DEFAULT_RESERVED,
): string {
  if (isDcCodeSegment(urlDc, reserved)) return urlDc as string
  if (isDcCodeSegment(storeDc, reserved)) return storeDc as string
  return firstDc || ''
}

/** `/` redirect: prefer saved activeDcCode over list[0]. No ghost default DC. */
export function rootRedirectDc(
  storeDc: string | null | undefined,
  firstDc: string | undefined,
  reserved: string[] = DEFAULT_RESERVED,
): string {
  if (isDcCodeSegment(storeDc, reserved)) return storeDc as string
  return firstDc || ''
}

/** After POST create — open the new DC, never reload a deleted code. */
export function pathAfterCreateDc(code: string): string {
  return `/${code}`
}

/** Drop stale localStorage DC when it is no longer in the list (post-wipe). */
export function reconcileActiveDcCode(
  active: string | null | undefined,
  codes: string[],
): string | null {
  if (active && codes.includes(active)) return active
  return codes[0] ?? null
}

/** Keep path after DC when switching ЦОД in the header. */
export function pathWithDcCode(pathname: string, newDc: string, currentDc: string): string {
  if (!currentDc) return `/${newDc}`
  const prefix = `/${currentDc}`
  if (pathname === prefix || pathname.startsWith(prefix + '/')) {
    return `/${newDc}` + pathname.slice(prefix.length)
  }
  return `/${newDc}`
}

export { DEFAULT_RESERVED as DC_RESERVED_SEGMENTS }
